import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mobile-premiere-featured-guest',
  templateUrl: './mobile-premiere-featured-guest.component.html',
  styleUrls: ['./mobile-premiere-featured-guest.component.css']
})
export class MobilePremiereFeaturedGuestComponent implements OnInit {

  @ViewChild('dialogTemplate') dialogTemplate: TemplateRef<any>;

  @Input('mobilePremiereDetails') mobilePremiereDetails:any;
  @Input('image') image:any;

  @Input('eventid') eventid: any;   //for celebrations feature guest line
  @Input('id') eventId: any;         //for spotlight feature guest line

  show:any;
  symposiums = false
  constructor(private dialog: MatDialog, private router: Router) { }

  ngOnInit(): void {
    if (this.router.url.includes('symposiums'))
      {
        this.symposiums = true
      }
      else{
       this.symposiums = false
      }
    if (this.show = !this.show)
      this.mobilePremiereDetails.cinejoyFeaturedGuests;
    else
      this.mobilePremiereDetails.featuredGuests;
  }

  openFeaturedGuestDetails(details: any) {
    const dialogRef = this.dialog.open(this.dialogTemplate, {
      data: {
        image: details.imageUrl,
        name: details.name,
        title: details.title,
        bio: details.bio,
        companyName: details.companyName
      }
    });
  }

  areBothPresent(title, companyName): boolean {
    return title?.length > 0 && companyName?.length > 0;
  }

}
